import React, { useEffect, useState } from 'react';
import MasterPage from 'components/MasterPage';
import { Row, Container, Card, Button } from 'react-bootstrap';
import { WidgetsOutlined, ArrowBackIos, Add } from '@material-ui/icons';
import masterAgentService from '../../services/master-agent-request';
import TableMasterAgent from 'components/TableMasterAgent';
import { Link, useHistory } from 'react-router-dom';
import Can from 'components/Can';
import { useCompany, useUser } from 'models';

export default function MyQuotes() {
  const history = useHistory();
  const user = useUser()
  const { company } = useCompany();

  const [filters, setFilters] = useState(!company ? {} : { company: company.document })
  const [data, setData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [isLoading, setIsLoading] = useState(false)
  const [filtersList, setFiltersList] = useState({
    'Status': {
      width: 1,
      type: 'select',
      comparator: 'equal',
      options: {}
    },
    'Razão Social Cliente': {
      width: 2,
      type: 'input',
      comparator: 'like',
    },
    'Periodo': {
      width: 2,
      ref: 'Data de Envio da Proposta',
      type: 'date',
      comparator: 'between',
      data: {
        from: { label: 'Periodo Inicial', value: null },
        to: { label: 'Periodo Final', value: null }
      }
    }
  });

  useEffect(() => {
    const get = async () => {
      setIsLoading(true)
      const response = await masterAgentService.getAllQuotes(filters)
      const { collection, columns } = response.data

      if (collection.length > 0) {
        for (let item of collection) {
          let aux = filtersList
          aux.Status.options[item.Status] = item.Status
          setFiltersList(aux)
        }
      }
      setColumns(columns)
      setData(collection)
      setIsLoading(false)
    }
    get();
  }, []);

  return (<>
    <Container fluid className='mb-5'>
      <Row className="mt-2">
        <Link to="/programs" className="link-back">
          <ArrowBackIos className="icon-title icon-back" />
          <h6 className="font-13 mt-3">Voltar</h6>
        </Link>
      </Row>
      <Row className="mt-1">
        <WidgetsOutlined className="icon-title col-auto p-0" />
        <h5 className="title-dashboard col-10 p-0">Pré Vendas - Minhas Propostas</h5>
      </Row>
      <Row className="">
        <Card.Body className="card-dashboard shadow bg-white rounded m-2 col-12 mb-5">
          <TableMasterAgent
            setFiltersList={setFiltersList}
            isLoading={isLoading}
            showActionsButton
            collection={data}
            columns={columns}
            filtersList={filtersList}
            additionalButtons={() => (
              <Can do="master-agent.opportunities" on="App">
                <Button 
                  className="btn-add mr-3"
                  onClick={() => history.push('/master-agent/my-quotes/opportunities')}
                >
                  Registro de Oportunidades
                </Button>
              </Can>
            )}
            btnAddProps={{
              url: '/master-agent/new-quote',
              label: 'Configurador Cotações'
            }}
            fileExportName={'MA-Minhas Propostas'}
          />
        </Card.Body>
      </Row>
    </Container>
  </>);
}
